import { Step } from "layout/models/step.model";
import { UserFormValues } from "models/login";

export namespace AppStateManager {
	export const setUserInfo = (values: UserFormValues) => {
		sessionStorage.setItem("userInfo", JSON.stringify(values));
	};
	export const getUserInfo = (): UserFormValues | undefined => {
		let _json = sessionStorage.getItem("userInfo") || "";

		if (!_json) return;
		return JSON.parse(_json) || undefined;
	};

	export const setIdPratica = (value: string) => {
		sessionStorage.setItem("idPratica", value);
	};
	export const getIdPratica = (): string | undefined => {
		return sessionStorage.getItem("idPratica") || undefined;
	};

	export const setIdCompany = (value: string) => {
		sessionStorage.setItem("idCompany", value);
	};
	export const getIdCompany = (): string | undefined => {
		return sessionStorage.getItem("idCompany") || undefined;
	};

	export const setIdCliente = (value: string) => {
		sessionStorage.setItem("idCliente", value);
	};
	export const getIdCliente = (): string | undefined => {
		return sessionStorage.getItem("idCliente") || undefined;
	};

	export const setInvitationData = (value: string) => {
		sessionStorage.setItem("invitationData", value);
	};
	export const getInvitationData = (): string | undefined => {
		return sessionStorage.getItem("invitationData") || undefined;
	};

	export const setReopenSteps = (value: Step[]) => {
		sessionStorage.setItem("reopenSteps", JSON.stringify(value));
	};
	export const getReopenSteps = (): Step[] | undefined => {
		let _json = sessionStorage.getItem("reopenSteps");

		if (!_json) return;
		return JSON.parse(_json) || undefined;
	};

	export const cleanState = () => {
		sessionStorage.clear();
	};
}
